import React, { Component } from 'react'
import PdfViewer from '../../components/PdfViewer/PdfViewer'
import Chat from '../../components/Chat/Chat'
import { connect } from 'react-redux'
import './ConferenceDetail.css'

class ConferenceDetail extends Component {

    componentWillMount = () => {
        const { isLogin } = this.props.login
        if (!isLogin) {
            this.props.history.push('/login')
        }
    }

    componentDidMount = () => {
        console.log('ConferenceDetail', this.props)
    }



    render() {
        const { url, doc_id, document_name } = this.props.location.state
        console.log(this.props)
        return (
            <div className='container' >


                <div className='conference-detail-container' >
                    <div className='conference-detail-left' >
                        <PdfViewer url={url} doc_id={doc_id} user={this.props.login.user.user_id} token={this.props.login.user.token} document_name={document_name} />
                    </div>
                    <div className='conference-detail-right' >
                        <Chat {...this.props} />
                    </div>

                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    login: state.login
})

export default connect(mapStateToProps)(ConferenceDetail)


// WEBPACK FOOTER //
// ./src/pages/ConferenceDetail/ConferenceDetail.js